import { ChangeDetectionStrategy, Component } from '@angular/core';

import { NumpadService } from 'packages/sports/web/app/src/numpad/numpad.service';

import { LINEAR_CONTAINER_STAKE_SERVICE } from '../../../stake/services/digital/linear/linear-container-stake.interface';
import { SingleBetGeneralStakeService } from '../../services/linear/single-bet-general-stake.service';

@Component({
    selector: 'bs-linear-single-bet-general-stake',
    templateUrl: './linear-single-bet-general-stake.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NumpadService, { provide: LINEAR_CONTAINER_STAKE_SERVICE, useClass: SingleBetGeneralStakeService }],
    standalone: false,
})
export class LinearSingleBetGeneralStakeComponent {}
